import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
`
